import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/6ced6ff0f79e5f13862e0ce4b61f6b3c.jpg"
          alt="King Square Club Interior"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <div className="mb-8">
          <img
            src="https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/a34b1e0ab002dc04c0156491411f9278.jpeg"
            alt="King Square Club Logo"
            className="h-32 w-32 mx-auto object-contain mb-6"
          />
        </div>
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight">
          KING SQUARE CLUB
        </h1>
        <p className="text-xl md:text-2xl text-amber-400 mb-4 font-light tracking-wide">
          Benin City's Premier Luxury Nightclub
        </p>
        <p className="text-base md:text-lg text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed">
          Experience the epitome of luxury nightlife. Where elegance meets entertainment, and every night becomes an unforgettable celebration.
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <Link
            to="/contact"
            className="bg-amber-500 hover:bg-amber-600 text-black px-10 py-4 rounded-full text-base font-bold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Reserve Your Table
          </Link>
          <Link
            to="/events"
            className="border border-white/60 hover:border-amber-400 hover:text-amber-400 text-white px-10 py-4 rounded-full text-base font-bold transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            View Events
          </Link>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
